'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { AbstractImage } from '@mntn-dev/ui-utilities'
import { useState } from 'react'
import { Icon } from '../../../icon/icon.tsx'
import type { IconSize } from '../../../icon/types/core.ts'
import { LoadingSpinner } from '../../../loading/loading-spinner.tsx'
import { type CardScale, useCardContext } from '../../use-card.ts'

export type CardImageCompactProps = {
  image: AbstractImage
  src?: string
  alt: string
  width?: number
  height?: number
  className?: string
}

export const cardImageCompactSizeMap: Record<
  CardScale,
  { width: number; height: number }
> = {
  sm: { width: 48, height: 48 },
  md: { width: 64, height: 64 },
  lg: { width: 72, height: 72 },
}

const iconSizeMap: Record<CardScale, IconSize> = {
  sm: 'lg',
  md: 'xl',
  lg: '2xl',
}

export const CardImageCompact = ({
  alt,
  className,
  height,
  image: Image,
  src,
  width,
}: CardImageCompactProps) => {
  const [loading, setLoading] = useState<boolean>(true)
  const { scale = 'lg' } = useCardContext()
  return (
    <div
      className={cn(
        'overflow-hidden rounded-lg bg-gray-800 opacity-90 relative flex items-center justify-center shrink-0',
        className
      )}
      style={{
        height: cardImageCompactSizeMap[scale].height,
        width: cardImageCompactSizeMap[scale].width,
      }}
    >
      {src ? (
        <>
          <Image
            src={src}
            alt={alt}
            width={width ?? cardImageCompactSizeMap[scale].width}
            height={height ?? cardImageCompactSizeMap[scale].height}
            onLoad={() => setLoading(false)}
            className={cn('object-cover overflow-hidden w-full h-full', {
              invisible: loading,
            })}
          />
          {loading && (
            <div
              className={cn(
                'w-full h-full flex items-center justify-center absolute left-0 top-0'
              )}
            >
              <LoadingSpinner className="text-primary-blue h-12 w-12" />
            </div>
          )}
        </>
      ) : (
        <Icon
          name="VideoIcon"
          size={iconSizeMap[scale]}
          className="text-primary-blue"
        />
      )}
    </div>
  )
}
